import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box, Paper } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Login } from '../login/Login';
import { Cadastrar } from '../cadastrar/Cadastrar';
import { useAuthContext } from '../../contexts';
import { EsqueciSenha } from './Esqueci-senha';
import CookieService from '../../services/autenticacao/CookieService';
import { Enviroment } from '../../enviroments';
import { UtilidadeService } from '../../services/api/utilidades/UtilidadesService';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                <Box sx={{ p: 3 }}>
                    <Grid container>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

type Props = {
    children?: React.ReactNode,
    visivel: boolean
};
export const Inicio: React.FC<Props> = ({ children, visivel = false }) => {
    const [value, setValue] = useState(0);
    const { isAuthenticated } = useAuthContext();
    const [visibleEsqueciSenha, setVisibleEsqueciSenha] = useState(false);
    const [naoMostrarLogin, setNaoMostrarLogin] = useState(false);
    const [mostrarLogin, seMostrarLogin] = useState(visivel);   

    useEffect(() => {

        verificarAmbiente();
        setNaoMostrarLogin(isAuthenticated);


    }, [isAuthenticated]);

    useEffect(() => {
        const token = CookieService.get("access_token");
        if (token === undefined) {
            seMostrarLogin(true);
        }
    }, [])

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setVisibleEsqueciSenha(false);
        if (newValue === 2) {
            setVisibleEsqueciSenha(true);
        }
        setValue(newValue);

    };

    const verificarAmbiente = () => {
        if (Enviroment.AMBIENTE_PRODUCAO) {
            if (window.location.protocol !== 'https:') {
                window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
            }
        }
    }

    return (
        <>{naoMostrarLogin ? <>{children}</> : <>{mostrarLogin && (
            <Grid container 
                style={{ width: "100vw" }} 
                height={value === 1 && UtilidadeService.isMobile() ? "132vh" : "100vh"}
                display={mostrarLogin ? "flex" : "none"}
                alignItems="center" justifyContent="center"
            >
                <Grid  alignItems="flex-start" justifyContent="center">
                    <Paper sx={{ width: UtilidadeService.isMobile() ? "330px" : '460px', margin: '0 auto' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChangeTabs} aria-label="basic tabs example" centered>
                                {!visibleEsqueciSenha && (<Tab label="ENTRAR" {...a11yProps(0)} />)}
                                {!visibleEsqueciSenha && (<Tab label="CADASTRAR" {...a11yProps(1)} />)}
                                {visibleEsqueciSenha && (<Tab label="RECUPERAR SENHA" {...a11yProps(2)} />)}
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0} >
                            <Login handleChangeTabs={handleChangeTabs} />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Cadastrar handleChange={handleChangeTabs} />
                        </TabPanel>
                        <TabPanel value={value} index={2} >
                            <EsqueciSenha handleChange={handleChangeTabs} />
                        </TabPanel>
                    </Paper>
                </Grid>
            </Grid >
        )}</>
        }
        </>
    )
}